import React from 'react';
import PageTitle from '../components/sections/PageTitle';
import ResumeSection from '../components/sections/Resume';

const Resume: React.FC = () => {
  return (
    <>
      <PageTitle 
        title="Resume"
        imageQuote="The commitment that drives my continuous learning and improvement."
        description={`"Hard work outweighs talent — every time."\n\n                    ~ Kobe Bryant`}
        // image="/assets/img/others/kobe_bryant_1.png"
        // imageAlt="Kobe Bryant"
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Resume' }
        ]}
      />
      <ResumeSection />
    </>
  );
};

export default Resume; 